import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export type MyAffiliate = {
  id: string;
  slug: string;
  name: string;
  tagline: string | null;
  description: string | null;
  logo_url: string | null;
  website: string | null;
  contact_email: string | null;
  location: string | null;
  category: string;
  subcategories: string[] | null;
  services: string[] | null;
  specialties: string[] | null;
  status: string;
  featured: boolean;
  owner_user_id: string | null;
  show_contact_email_public: boolean;
  created_at: string;
  updated_at: string;
};

export function useMyAffiliates() {
  const { user, loading: authLoading } = useAuth();
  const query = useQuery({
    enabled: !!user,
    queryKey: ["my-affiliates", user?.id],
    queryFn: async (): Promise<MyAffiliate[]> => {
      const { data, error } = await supabase
        .from("affiliates")
        .select("*")
        .eq("owner_user_id", user!.id)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return (data ?? []) as MyAffiliate[];
    },
  });
  return {
    loading: authLoading || query.isLoading,
    affiliates: query.data ?? [],
    refetch: query.refetch,
  };
}